import { Component, input, OnInit, signal, computed } from '@angular/core';
import { DocumentItemPartial, DocumentItemTypeEnum } from '@domain';
import { TranslatePipe } from '@ngx-translate/core';
import { RaViewerTextComponent } from 'src/app/shared/components/ra-viewer-text/ra-viewer-text.component';

import { itemTextColor, itemTextSizeRem } from '../../../../text-style-options';
@Component({
    selector: 'video-data',
    templateUrl: 'video-data.component.html',
    styleUrls: ['video-data.component.scss', '../../document-preview.scss'],
    imports: [RaViewerTextComponent, TranslatePipe],
})
export class VideoDataComponent implements OnInit {
    public item = input.required<DocumentItemPartial>();
    /** Tamanho e cor próprios da descrição (configs textSize/textColor), como no PDF. */
    public descriptionSize = computed(() => itemTextSizeRem(this.item()?.configs));
    public descriptionColor = computed(() => itemTextColor(this.item()?.configs));
    public listVideos: string[] = [];
    public showFullScreen = signal(false);

    ngOnInit(): void {
        this._checkImageType();
    }

    private _checkImageType(): void {
        switch (this.item()?.type) {
            case DocumentItemTypeEnum.VIDEO:
                this.listVideos = [this.item().value];
                break;
            case DocumentItemTypeEnum.GROUP_VIDEO:
                this.listVideos = this.item().value.map(item => item.url);
                break;
        }
    }
}
